module.exports = __webpack_public_path__ + "static/media/S.0dec278b.gif";